import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import type { ErrorProps } from '../app/global-error';
import { usePathname } from 'next/navigation';
import { DATADOG_FLOW_TYPE, DATADOG_TAGS, sendLogToDataDog } from '@/lib/utils/datadogLogger';
import { processDatadogTags, processErrorForDatadog } from '@/lib/utils/datadogHelpers';
function ErrorComponent({
  error
}: ErrorProps) {
  const isUpgrade = usePathname()?.includes('/upgrade');
  useEffect(() => {
    Sentry.captureException(error, {
      tags: {
        'error-component': 'component'
      }
    });
    const errorContext = processErrorForDatadog(error);

    // Have message contain first 35 characters of error message
    sendLogToDataDog({
      logMessage: `Error Component - ${errorContext?.errorMessage ? (errorContext.errorMessage as string).substring(0, 35) : 'Unknown Error'}`,
      condensedTags: '',
      context: errorContext
    });
  }, [error]);
  const reloadPage = () => {
    window.location.reload();
  };
  return <div className='min-h-[calc(100vh-180px)]' data-sentry-component="ErrorComponent" data-sentry-source-file="ErrorComponent.tsx">
      <div className='mx-auto max-w-prose text-center'>
        <h2 className='pt-10 text-2xl'>Something went wrong.</h2>
        You can{' '}
        <button className='text-red-500' onClick={reloadPage} type='submit'>
          try again
        </button>{' '}
        or reload the page.
        <p className='pt-4'>
          If the problem persists, contact membership services (
          <a className='text-red-500' href='mailto:support@whoop.com'>
            support@whoop.com
          </a>
          )
          {!isUpgrade ? <>
              {' '}
              or join WHOOP through another method, such as{' '}
              <a className='text-red-500' href='https://www.amazon.com/stores/WHOOP/page/E4D3336B-5B33-4CA5-883E-D915A462FA58' rel='noopener' target='_blank'>
                Amazon.com
              </a>
              .)
            </> : null}
        </p>
      </div>
    </div>;
}
export default ErrorComponent;